// extracted by mini-css-extract-plugin
export default {"starIcon":"waterbody_follow_button_logged_out__starIcon--Xmo7"};